/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_AvailableInputs */



/**
* | output |
* | --- |
* | "A new version is available." |
*
* @param {Update_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const update_available = /** @type {((inputs?: Update_AvailableInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_AvailableInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une nouvelle version est disponible.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Hay una nueva versión disponible.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Uma nova versão está disponível.")
	if (locale === "it") return /** @type {LocalizedString} */ ("È disponibile una nuova versione.")
	return /** @type {LocalizedString} */ ("A new version is available.")
});